import { fetch } from '../api';
import configApi from '../../constants/ApiConfig';

const endPoints = {
    authenticate    : '/oauth/v2/token',
    revoke          : '/oauth/v2/auth/logout',
    refresh         : '/oauth/v2/token',
    getMe           : '/api/me/',
    saveMe          : '/api/me/update',
    changeCostumer  : '/api/me/change-costumer/',
    createCostumer  : '/api/costumer/',
    disabledCostumer  : '/api/organisations/deconnect',
};



export const authenticate = (username, password) => fetch(
    endPoints.authenticate, {
        username,
        password,
        client_id       : configApi.clientId,
        client_secret   : configApi.clientSecret,
        grant_type      : 'password'
    }, 
    'get',
);

export const refresh = (token) => fetch(
    endPoints.refresh, {
        refresh_token   : token,
        client_id       : configApi.clientId,
        client_secret   : configApi.clientSecret,
        grant_type      : 'refresh_token'
    },
    'get' 
    );

export const revoke = tokens => {

    if(tokens.token) return fetch(endPoints.revoke, { tokens }, 'post');

    return Promise.resolve(true);
    
}

export const getMe = () => fetch(endPoints.getMe);

export const saveMe = (data) => fetch(endPoints.saveMe, data, 'post');

export const changeCostumer = (id) => fetch(`${endPoints.changeCostumer}${id}`, false, 'get');

export const createCostumer = (data) => fetch(`${endPoints.createCostumer}`, data, 'post');

export const disabledCostumer = () => fetch(endPoints.disabledCostumer, {}, 'get');



// WEBPACK FOOTER //
// ./src/services/session/api.js